import { Config } from '../../config/config';

export class GoogleService {
  private static tokenClient: any;
  private static _isInitialized = false;

  private static _onLoginFinished: ((response: any) => void | Promise<void>) | null = null;

  public static init() {
    if (this._isInitialized) return;

    const scriptTag = document.createElement('script');
    scriptTag.src = 'https://accounts.google.com/gsi/client';
    scriptTag.async = true;
    scriptTag.defer = true;
    scriptTag.onload = () => {
      this.tokenClient = (window as any).google.accounts.oauth2.initTokenClient({
        client_id: Config.GOOGLE_CLIENT_ID,
        scope: 'openid profile email https://www.googleapis.com/auth/user.birthday.read https://www.googleapis.com/auth/user.gender.read',
        callback: async (tokenResponse: any) => {
          if (this._onLoginFinished) {
            try {
              await this._onLoginFinished(tokenResponse);
            } catch (err) {
              console.error('Google login callback error:', err);
            }
          }
        },
      });
    };

    document.body.appendChild(scriptTag);
    this._isInitialized = true;
  }

  /**
   * Triggers login and sets the async/sync callback handler
   * @param onLoginFinished The callback function after login completes
   */
  public static login(onLoginFinished: (response: any) => void | Promise<void>) {
    this._onLoginFinished = onLoginFinished;

    if (this.tokenClient) {
      this.tokenClient.requestAccessToken();
    } else {
      console.error('Google token client not initialized yet.');
    }
  }
}
